import { useEffect, useRef } from 'react'

/** Intervalo e teto da releitura (AN-PP3 §3.3: a cada 5 s, no máximo 2 min). */
export const INTERVALO_RELEITURA_MS = 5_000
export const TETO_RELEITURA_MS = 120_000

/**
 * Relê o checklist a cada 5 s enquanto houver item "Em verificação" (o Tika ainda lendo o
 * arquivo), por no máximo 2 min contados do início da verificação. Para quando nada mais está
 * em verificação ou o componente sai da tela.
 */
export const useReleituraEmVerificacao = (emVerificacao: boolean, reler: () => void): void => {
  const relerRef = useRef(reler)
  relerRef.current = reler
  const inicioRef = useRef<number | null>(null)

  useEffect(() => {
    if (!emVerificacao) {
      inicioRef.current = null
      return undefined
    }
    if (inicioRef.current == null) inicioRef.current = Date.now()
    const id = setInterval(() => {
      if (inicioRef.current != null && Date.now() - inicioRef.current >= TETO_RELEITURA_MS) {
        clearInterval(id)
        return
      }
      relerRef.current()
    }, INTERVALO_RELEITURA_MS)
    return () => clearInterval(id)
  }, [emVerificacao])
}
